export type ProcessDialogContentVariant =
  | 'spacious'
  | 'default'
  | 'comfortable'
  | 'compact'
  | 'veryCompact'
  | 'fullLength'
  | 'none';

export const PROCESS_DIALOG_CONTENT_PADDING: Record<
  ProcessDialogContentVariant,
  string
> = {
  spacious: '48px 64px',
  default: '32px 48px',
  comfortable: '24px 32px',
  compact: '16px 24px',
  veryCompact: '8px 16px',
  fullLength: '24px 0px',
  none: '0px',
};

export interface ProcessDialogAction {
  label: string;
  onClick: () => void;
  variant?: 'contained' | 'outlined' | 'text';
  color?:
    | 'primary'
    | 'secondary'
    | 'error'
    | 'success'
    | 'warning'
    | 'info'
    | 'inherit';
  disabled?: boolean;
}
